<template>
   <div class="col-md-12">
       <h5>{{ label_product_category }}</h5>
        <div class="row">
            <template v-for="(item, index) in mixedStep.items">
            <div v-if="item.product_count"
            :key = "index"
            class="col-md-6 col-lg-4 col-xl-4"
            >

                <div class="solution-category" :class="{ active: item.categoryId == mixedStep.selected, disabled: !item.product_count}">
                    <div class="category-items">
                        <!-- <span class="pointer" style="color:#005cb9; font-weight:700; font-size:22px" @click="selectCategory(item.product_count, item.categoryId)">
                        {{ item.title }}
                        </span> -->
                        <div>
                            <img class="pointer" :src="item.image" alt style="width:100%;" @click="selectCategory(item.product_count, item.categoryId, item.title)" />
                        </div>
                    </div>
                    <div class="item-details">
                        <div v-if="item && item.category_meta && item.category_meta.solution_title_2" style="color:#000000; font-weight:700; font-size:22px; display:block;">
                            ({{ item.category_meta.solution_title_2 }})
                        </div>
                        <div class="pointer" style="color:#000000; font-weight:700; font-size:22px" @click="selectCategory(item.product_count, item.categoryId, item.title)">
                            {{ item.title }}
                        </div>
                        <hr>
                        <div style="font-size:14px; padding-top:10px; padding-bottom:10px;">
                            {{ item.desc }}
                        </div>
                        <hr>
                        <div v-if="item && item.category_meta && item.category_meta.solution_shape">
                            <span style="border-style: solid; border-color: #CCC; border-radius: 3px; display: inline-block; border-width: 1px; padding:8px;">
                                <img style="height: 21px;vertical-align: text-top;margin: 0 4px;" v-bind:src="'/cdn/images/solutions/' + item.category_meta.solution_shape + '.png'" />  Shape
                            </span>
                        </div>

                        <br />
                        <br />
                        <div class="button" v-if="item.product_count">
                            <button @click="selectCategory(item.product_count, item.categoryId, item.title)" class="btn btn-hover btn-wishlist"
                            :class="{ 'btn-green-full': item.categoryId == mixedStep.selected, 'btn-orange-full': item.categoryId != mixedStep.selected }"
                            >
                            {{ item.categoryId == mixedStep.selected ? 'SELECTED' : 'SELECT'}}
                            </button>
                        </div>
                    </div>
                </div>

            </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "solution-categories",
    props: {
        mixedStep : Object,
        label_na_for_your_vehicle: {
            type: String,
            required: true,
            default: "Not available for your vehicle"
        },
        label_product_category: {
            type: String,
            default: "Product Category"
        },

    },
     mounted() {
        //  if there is only one option, select it
        if(this.mixedStep && this.mixedStep.items && this.mixedStep.items.length == 1) {
            let item = this.mixedStep.items[0];
            if(item.product_count && item.product_count > 0) {
                this.$emit("selectCategory", item.categoryId);
            }
        }
    },
    methods: {
        selectCategory(product_count, categoryId, categoryTitle) {
            if (product_count && product_count > 0) {
                this.$emit("selectCategory", categoryId);
                ga('send','event', 'Fit My Vehicle', 'Product Category', categoryTitle);
            gtag('event', 'fit_my_vehicle_product_category', {'category':'Fit My Vehicle', 'action':'Product Category', 'value':categoryTitle});
            }
        }
    }
};
</script>

<style lang="scss" scoped>
    .solution-category {
        padding: 0;

        .category-items {
            border-bottom: 1px solid #F8F8F8;
        }

        .item-details {
            padding: 25px;
            background-color: #F8F8F8;
        }
    }
</style>
